import { render } from "./CourseEditorButton.vue?vue&type=template&id=4f02e35a&ts=true"
import script from "./CourseEditorButton.vue?vue&type=script&lang=ts"
export * from "./CourseEditorButton.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__